import axios from 'axios';

export class FichaIndividual {

  static async buscaFichaIndividual(turmaId, alunoId, semestre, nomeAluno, ano, segmentoId, serieId, escolaId) {
    return axios.get(`/dados-ficha-individual/${turmaId}/${alunoId}/${semestre}/${nomeAluno}/${ano}/${segmentoId}/${serieId}/${escolaId}`)
  }
}
